export const bigDataTop = [
	{
		title: '总交易额',
		value: 0,
		suffix: '元',
		decimals: 2,
		separator: ','
	},
	{title: '总订单数', value: 0, suffix: '单', decimals: 0, separator: ''},
	{title: '联盟商家', value: 0, suffix: '家', decimals: 0, separator: ''},

]
export const bigDataBottom = [
	{
		title: '学员总数',
		value: 0,
		suffix: '人',
		decimals: 0,
		separator: ''
	},
	{title: '店铺总数', value: 0, suffix: '家', decimals: 0, separator: ''},

]
export const country_list = [
	{country_code: 'US', value: 0,x:37.6,y:44.8},
	{country_code: 'CA', value: 0,x:38.6,y:38.8},
	{country_code: 'BR', value: 0,x:39.6,y:58.8},
	{country_code: 'RU', value: 0,x:60.6,y:36.8},
	{country_code: 'JP', value: 0,x:66.6,y:45.8},
	{country_code: 'GB', value: 0,x:47.6,y:39.8},
	{country_code: 'MX', value: 0,x:31.6,y:48.8},
	{country_code: 'ES', value: 0,x:44.6,y:44.8},
	{country_code: 'IT', value: 0,x:50.6,y:44.8},
	{country_code: 'DE', value: 0,x:49.6,y:41.8},
	{country_code: 'FR', value: 0,x:44.6,y:41.8},
	{country_code: 'AU', value: 0,x:65.6,y:64.8},
	{country_code: 'SA', value: 0,x:53.6,y:48.8},
	{country_code: 'SG', value: 0,x:62.3,y:55.3},

]
